import Vue from 'vue';

export default {

    // configuracion 
    // ------------------------

    get(resource) {
        return Vue.$http.get(`${resource}`);
    },

    post(resource, params) {
        return Vue.$http.post(`${resource}`, params);
    },

    update(resource, params) {
        return Vue.$http.put(`${resource}`, params);
    },

    put(resource, params) {
        return Vue.$http.put(`${resource}`, params);
    },

    delete(resource) {
        return Vue.$http.delete(resource).catch(error => {
            throw new Error(`[RWV] ApiService ${error}`);
        });
    },

    postFileResult(resource, params) {
        return Vue.$http.post(`${resource}`, params, {
            responseType: "arraybuffer",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/pdf"
            }
        });
    
    },
    getBlob(resource) {
        return Vue.$http.get(`${resource}`, {
            responseType: "blob",
        });
    
    },
    postBlob(resource,params) {
        return Vue.$http.post(`${resource}`, params,{
            responseType: "blob",
        });
    
    }
}
